import React, { useState, useEffect } from 'react';
import { Http } from '../utils/http';
import AppContext, {IAppContext} from './AppContext';

const AppContextProvider: React.FC<any> = (props: any) => {
  const [appContext, setAppContext]: [any, any] = useState({
    sessionLoaded: null,
    cart: null,
    user: null,
    sessionVersion: null,
    captchaVerified: null,
    showLoggedOutMessage: false,

    /* Update the currently logged in user */
    setUser: (user: any) => {
      setAppContext((oldState: IAppContext) => Object.assign({}, oldState, { user: user }));
    },

    setCaptchaVerified: (verified: boolean) => {
      setAppContext((oldState: IAppContext) => Object.assign({}, oldState, { captchaVerified: verified }));
    },

    /* Record the current user session token */
    setSessionVersion: (version: string) => {
      setAppContext((oldState: IAppContext) => {
        return Object.assign({}, oldState, {
          sessionVersion: version,
        });
      });
    },

    /* Mark the session loading process as complete or not */
    setSessionLoaded: (value: boolean) => {
      setAppContext((oldState: IAppContext) => {
        return Object.assign({}, oldState, { sessionLoaded: value });
      });
    },

    setIsImpersonating: (value: boolean) => {
      setAppContext((oldState: IAppContext) => {
        return Object.assign({}, oldState, { isImpersonating: value });
      });
    },

    setShowLoggedOutMessage: (value: boolean) => {
      setAppContext((oldState: IAppContext) => Object.assign({}, oldState,
                                                             {
                                                               showLoggedOutMessage: value,
      }));
    },

    refreshCart: (): Promise<any> => {
      return new Promise((resolve, reject) => {
        Http.get()
            .getCart()
            .then(
              (data: any) => {
                setAppContext((oldState: IAppContext) => Object.assign({}, oldState, { cart: data }));
                resolve();
              },
              () => {
                reject();
              }
            )
      });
    },

    /* Log out the current user */
    clearSession: (showLogout?: boolean) => {
      setAppContext((oldState: IAppContext) => {
        return Object.assign({}, oldState, {
          isImpersonating: false,
          sessionLoaded: true,
          sessionVersion: '',
          user: null,
          cart: null,
          captchaVerified: null,
        });
      });
    }
  });

  useEffect(() => {
    /* Trigger our user lookup on first load */
    appContext.setSessionVersion('');
  }, []);

  /* If a child component refeshes the session, fetch the current user */
  useEffect(() => {
    Http.get()
        .getCurrentUser()
        .then(
          (response: any) => {
            setAppContext((oldState: IAppContext) => Object.assign(
              {},
              oldState,
              {
                user: response.data,
                captchaVerified: true,
                sessionLoaded: true,
                showLoggedOutMessage: false,
            }));

            appContext.refreshCart();
          },
          () => {
            setAppContext((oldState: IAppContext) => Object.assign(
              {},
              oldState,
              {
                user: null,
                cart: null,
                sessionLoaded: true,
            }));

            Http.get().isCaptchaVerified().then((json: any) => {
              appContext.setCaptchaVerified(json.status === 'verified');
            })
          }
        );
  },
  // Adding appContext to the deps array here (as suggested by jslint) creates a loop.
  //
  [appContext.sessionVersion]);

  if (appContext.sessionLoaded) {
    return <AppContext.Provider value={appContext}>{props.children}</AppContext.Provider>;
  } else {
    return <></>;
  }
};

export default AppContextProvider;
